import Helpers from '@/shared/helpers/functions';

class Period {
  constructor (data = {}) {
    this.id = data.id;
    this.status = data.status;
    this.workStockReason = data.workStockReason;

    this.startDate = data.startIsoDate || new Date().toISOString().substr(0, 10);
    this.reportDate = data.reportIsoDate || new Date().toISOString().substr(0, 10);

    this.disabilityRate = Helpers.Percentage.parse(data.disabilityRateAsPercentage) || '100,00';
    this.processedUntilDate = data.indemnityProcessedUntilIsoDate;

    this.typeOfReport = data.typeOfReport || 'Period';
  }

  isPeriod () {
    return this.typeOfReport === 'Period';
  }

  getBody () {
    return {
      startIsoDate: this.startDate,
      disabilityRateAsPercentage: parseFloat(this.disabilityRate.replace(',', '.'))
    };
  }
}

export {
  Period
};
